module.exports = __webpack_public_path__ + "static/img/tong.2e7720ee.png";